<template>
  <div
    class="base-input-file"
    :class="classObject"
  >
    <input
      ref="input"
      type="file"
      class="base-input-file__input-file"
      :multiple="multiple"
      :accept="accept"
      :name="name"
      @change="onChange($event)"
    >

    <div
      class="base-input-card__button"
      :class="{'base-input-card__button--filled': fileName}"
      @click="onClick()"
    >
      <template v-if="!fileName">
        <font-awesome-icon
          class="base-input-card__button__icon"
          :icon="icon"
        />
        <div>Attach file</div>
        <br>
        <div
          v-if="error_message"
          class="upload-error"
        >
          {{ error_message }}
        </div>
      </template>

      <template v-if="fileName">
        <font-awesome-icon
          class="base-input-card__button__icon"
          icon="file"
        />
        <!-- <div>{{ data }}</div> -->
        <div>{{ fileName }}</div>
      </template>
    </div>
    <div v-if="fileName">
      <font-awesome-icon
        class="base-input-card__button__icon--close"
        icon="times"
        @click="clean()"
      />
    </div>
    <div
      v-if="loading"
      class="base-input-file__progress"
      :style="{width: progress+'%'}"
    />
  </div>
</template>
<script>
import BaseInputFileCard from '../../components/Base/BaseInputFileCard';
import api from '../../_api';

const MAX_FILE_SIZE = 10000000;

export default {
  name: 'EditorAttachFile',
  extends: BaseInputFileCard,
  props: {
    accept: {
      type: String,
      default: 'image/png, image/jpeg, application/pdf, application/msword',
    },
    show: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    multiple: { // TODO: implement!
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      progress: 0,
      error_message: null,
    };
  },
  watch: {
    show(newval) {
      if (newval) {
        console.log('upload attachment');
        this.$refs.input.click();
      }
    },
    clear(newval) {
      if (newval) {
        console.log('clear attachment');
        this.clean();
      }
    },
  },
  methods: {
    clean() {
      this.fileName = '';
      this.$refs.input.value = '';
      this.error_message = null;
      console.log('Cleaned');
      this.$emit('cleaned');
    },
    onUploadProgress(progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      this.progress = percentCompleted;
      this.$emit('progress', this.progress);
    },
    onChange({ target: { files } }) {
      this.error_message = null;
      if (files.length <= 0) {
        return;
      }
      const config = {
        onUploadProgress: this.onUploadProgress.bind(this),
      };
      // Validate file size
      const file = files[0];
      console.log('File size: ', file.size);
      if (file.size > MAX_FILE_SIZE) {
        this.error_message = `Unable to upload file: File size is too large. Files can be up to ${this.$options.filters.formatSize(MAX_FILE_SIZE)}`;
        this.$emit('error', this.error_message);
        return;
      }
      const form = new FormData();
      form.append('file', file);

      // this.fileName = file.name
      // this.file = file
      this.loading = true;
      this.$emit('upload-started', file.name);
      api.post('/upload/', form, config)
        .then((res) => {
          console.log('File uploaded.');
          this.$emit('uploaded', res.data.url);
          this.fileName = file.name;
          this.dirty = true;
          this.loading = false;
        })
        .catch((error) => {
          console.log('Something went wrong :(');
          console.error(error);
          console.log('Error', error.response.status, error.response.data);
          this.error_message = 'Unable to upload file. Please contact your account representative for assistance.';
          this.$emit('error', this.error_message);
        });
    },

  },

};
</script>

<style lang="scss" scoped>
.upload-error{
    color: #FF0F0F
}
.base-input-file{
    position: relative;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f2f2f2;
}
.base-input-file__progress{
    background-color: rgba(#97B9CD, 0.1);
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0%;
    transition: 0.2s all;
}
.base-input-card__button{
    background-color: transparent;
    justify-content: start;
    cursor: pointer;
}
.base-input-card__button__icon--close{
    margin-right: 1rem;
    opacity: 0.5;
    cursor: pointer;
}
</style>
